// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {Fragment, useContext} from 'react';
import styles from './cms_switcher.module.less';
import {Button, i_button_props} from '../../../../shared/button';
import {App_context} from 'hola_app_context';
import cn from 'classnames';

interface i_cms_switcher_props extends Pick<i_button_props,
    'caption'|'on_click'>
{
    secondary?: boolean;
    can_edit?: boolean;
}

export const Cms_switcher = ({caption, on_click, secondary = false,
  can_edit}: i_cms_switcher_props)=>{
    const {user, is_client} = useContext(App_context);
    if (!is_client)
      return <Fragment/>;
    if (!(can_edit ?? user?.allow_edit_content))
      return <Fragment/>;
    return <div className={cn(styles.cms_switcher,
      secondary && styles.cms_switcher_secondary)}>
      <Button
        size={'lg'}
        caption={caption}
        on_click={on_click}
        round={false}
      />
    </div>;
};
